import { AfterViewInit, booleanAttribute, Component, ElementRef, EventEmitter, Input, numberAttribute, Output, ViewChild } from '@angular/core';
import { IFederationDto } from '@models/federation-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';

@Component({
  selector: 'sigecom-select-search-container',
  template: `
      <div
        class="rounded-md border border-sigecom-{{ errorMessage ? 'danger' : 'outlined-gray' }} min-h-[3.75rem] transition-colors duration-300 ease-in
        text-sigecom-outlined-gray p-2"
        [ngClass]="{
          'pointer-events-none opacity-30': isDisabled,
          'border-sigecom-info ring-1 ring-blue-500': !errorMessage && (isRequired && enableRequiredBorder),
        }"
      >
        <div  class="flex items-center justify-between">
          <label class="font-bold flex text-sm p-2 mb-1 w-full text-sigecom-{{ errorMessage ? 'danger' : 'gray' }}">
            {{ label }} <p class="text-sigecom-danger">{{ isRequired ? '*' : '' }}</p>
          </label>
        </div>

        <div class="flex gap-2 mb-2">
          <sigecom-input-container *ngIf="labelSearch != '' && inputContainerShow" class="w-full" [label]="labelSearch" >
            <input
            class="min-h-[1rem]"
            #searchInput sigecom-input type="text" placeholder="Pesquise..."
            (debouncedInput)="onSearchChange(searchInput.value)"
            (keyup.enter)="onSearchChange(searchInput.value)"/>
          </sigecom-input-container>

          <div *ngIf="!inputContainerShow" class="w-full border border-solid rounded-md border-sigecom-gray text-sigecom-gray">
            <input class="w-full"
            #searchInput sigecom-input type="text" placeholder="Pesquise..."
            (debouncedInput)="onSearchChange(searchInput.value)"
            (keyup.enter)="onSearchChange(searchInput.value)"/>
          </div>

          <ng-content select="[extra-filters]"></ng-content>
        </div>

        <div
          class="border min-h-56 border-sigecom-gray rounded-md bg-white p-2 transition-all duration-200 hover:border-gray-400"
          #contentWrapper>
          <ng-content></ng-content>
        </div>

        <div class="flex items-center justify-center gap-4 mt-2" *ngIf="enablePagination">
            <p class="font-normal text-sm">Página: </p>
            <strong class="flex items-center gap-2.5 text-pec-tx-primary">
              <button type="button" (click)="prevPage()" class="disabled:text-sigecom-gray" [disabled]="currentPage.page === 0">
                <fa-icon icon="angle-left" class="text-lg"/>
              </button>
              <span class="text-sm">{{ currentPage.page! + 1  }}</span>
              <button type="button" (click)="nextPage()" class="disabled:text-sigecom-gray" [disabled]="currentPage.page! >= totalPages! - 1">
                <fa-icon icon="angle-right" class="text-lg"/>
              </button>
            </strong>
            <p class="font-normal text-sm">Itens: </p>
            <strong class="flex items-center gap-2.5 text-pec-tx-primary">
              <button type="button" (click)="subSize()" class="disabled:text-sigecom-gray" [disabled]="currentPage.size! <= minSize">
                <fa-icon icon="angle-left" class="text-lg"/>
              </button>
              <span class="text-sm">{{ currentPage.size }}</span>
              <button type="button" (click)="addSize()" class="disabled:text-sigecom-gray" [disabled]="currentPage.size! >= maxSize">
                <fa-icon icon="angle-right" class="text-lg"/>
              </button>
            </strong>
          </div>
      </div>
      <div *ngIf="errorMessage" class="text-xs mt-1 text-sigecom-danger">
        <div>
            {{ errorMessage }}
        </div>
      </div>
  `,
  styleUrls: ['./select-search-container.component.scss']
})
export class SelectSearchContainerComponent implements AfterViewInit {
  @ViewChild('contentWrapper') content?: ElementRef;
  @Input() label: string = "[ DEFAULT LABEL ]";

  // Para nao perder a dinamica das outras telas de usar apenas um input com o nome
  // criei dois inputs para conseguir deixar nessa dinamica
  @Input() labelSearch: string = "";
  @Input() inputContainerShow: boolean = false;

  @Input() federations: IPage<IFederationDto> = {};
  @Input({ transform: booleanAttribute }) enablePagination: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() enableRequiredBorder: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() errorMessage?: string;
  @Output() searchEmmit: EventEmitter<any> = new EventEmitter<string | undefined>();

  @Input() set page(value: number) {
    this.currentPage.page = value ?? 0;
  }
  @Input() set size(value: number) {
    this.currentPage.size = value ?? 10;
  }

  currentPage: PageRequest = { page: 0, size: 10 };

  @Input() totalPages: number = 10;
  @Output() pageChange = new EventEmitter<PageRequest>();

  protected maxSize = 100;
  protected minSize = 10;

  onPageChange(page: number) {

  }

  ngAfterViewInit(): void {
    const selectElement: HTMLSelectElement = this.content?.nativeElement.getElementsByTagName("select")[0];
    selectElement.size = 5;
    selectElement.classList.add("select-search");
  }

  filterByFederation(id: number) {

  }

  searchFederationsByName(fedTxNome: string) {

  }

  loadFederationsPaged(page: number) {

  }

  onSearchChange(newValue: string) {
    this.currentPage.page = 0;
    this.searchEmmit.emit(newValue === "" ? undefined : newValue);
  }

  nextPage() {
    if (this.currentPage.page! < this.totalPages! - 1) {
      this.currentPage.page!++;
    }
    this.pageChange.emit({ ...this.currentPage });
  }

  prevPage() {
    if (this.currentPage.page! > 0) {
      this.currentPage.page! -= 1;
    }
    this.pageChange.emit({ ...this.currentPage });
  }

  addSize() {
    if (this.currentPage.size! < this.maxSize) {
      this.currentPage.size! += 10;
      this.currentPage.page = 0;
    }
    this.pageChange.emit({ ...this.currentPage });
  }

  subSize() {
    if (this.currentPage.size! > this.minSize) {
      this.currentPage.size! -= 10;
      this.currentPage.page = 0;
    }
    this.pageChange.emit({ ...this.currentPage });
  }
}
